{
    "main_h1": "Novità da e per Zurigo",
    "date_published": "Pubblicato il",
    "date_modified": "Ultimo aggiornamento",
    "back_to_feed": "Torna alla panoramica",
    "PROMOTION": "Promozione",
    "SOCIETY": "Società",
    "FREETIME": "Tempo libero",
    "NEWS": "Attualità"
}